<template>

    <Card >
      <AjaxForm v-if="payment_type" :route="'paymentType/Edit/'+id">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="عنوان..."
                         label="عنوان"
                         type="text"
                         :model-value="payment_type.title"
                         name="title"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="تعداد روز..."
                         label="تعداد روز"
                         :model-value="payment_type.n_day"
                         type="number"
                         name="n_day"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-6">
            <CustomInput placeholder="توضیحات..."
                         label="توضیحات"
                         :model-value="payment_type.description"
                         type="textarea"
                         name="description"></CustomInput>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-10 col-sm-8 col-md-5 mx-auto">
            <button class="btn btn-info btn-block" type="submit">ویرایش اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
      <div v-else-if="error" class="alert alert-danger">{{error}}</div>
    </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import {mapActions} from "vuex";
export default {
  name: "PaymentTypeAdd",
  components: {CustomInput, AjaxForm, Card},
  data(){
    return{
      id : this.$route.params.id,
      payment_type : null,
      error : null,
    }
  },
  mounted()
  {
    this.setPageTitle('ویرایش نوع پرداخت');
    this.setShowHead(true);
    this.initPage();
  },
  methods :{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.error = null;
      this.payment_type = null;
      this.id = this.$route.params.id;
      const result = await AppApi.getPaymentTypeInfo(this.id);
      if (result.ok)
      {
        this.payment_type = result.payment_type;
      }
      else
      {
        this.error = result.error;
      }
      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>

</style>